module.exports = __webpack_public_path__ + "img/ring_r_o_1_1.ba72e05a.png";